import {
  birthDate,
  changesVerified,
  checkChanges,
  code,
  edit,
  phoneAgain,
  profile,
  telegram,
  user,
  saveBirthDate,
} from '../../api/profile/index';

import { createAsyncThunk } from '@reduxjs/toolkit';
import actions from '../actions/index';

export const saveBirthDateThunk = createAsyncThunk(
  'profile/saveBirthDate',
  async (data) => {
    const res = await saveBirthDate(data);
    return res.data;
  }
);
// for profile
export function getProfileThunk(data) {
  return (dispatch) => {
    dispatch(actions.profile.startFetching());
    profile(data)
      .then(res => {
        if (res.data.info.status) {
          dispatch(actions.profile.userInfo(res.data.data.user));
          localStorage.setItem('user', JSON.stringify(res.data.data.user));

          dispatch(actions.profile.userConfirmInfo(res.data.data.confirmationInformations));
          localStorage.setItem('confirmInfo', JSON.stringify(res.data.data.confirmationInformations));

          dispatch(actions.profile.setTimesToLesson(res.data.data.times));
          localStorage.setItem('times', JSON.stringify(res.data.data.times));

          dispatch(actions.profile.setTimezones(res.data.data.timezones || []));
        }
      })
      .catch(error => {
        dispatch(actions.profile.profileError(error.response.data.data));
      })
      .finally(() => dispatch(actions.profile.stopFetching()));
  };
}

// for another pages
//
// /user/info викликається на маунті КОЖНОЇ сторінки кабінету (13 місць) —
// на кожен перехід між розділами летів однаковий запит. Тримаємо позначку
// останнього успішного фетча і протягом TTL не повторюємо його; force
// пробиває кеш там, де свіжість критична (напр. після читання сповіщень).
const USER_INFO_TTL_MS = 60 * 1000;
let userInfoStamp = { token: null, at: 0 };

export function getUserInfoThunk(data) {
  return (dispatch) => {
    if (
      !data?.force
      && data?.token === userInfoStamp.token
      && Date.now() - userInfoStamp.at < USER_INFO_TTL_MS
    ) {
      return;
    }

    userInfoStamp = { token: data?.token, at: Date.now() };
    dispatch(actions.profile.startFetching());
    user(data)
      .then(res => {
        if (res.data.info.status) {
          dispatch(actions.profile.userInfo(res.data.data.user));
          localStorage.setItem('user', JSON.stringify(res.data.data.user));
          dispatch(actions.profile.contacts(res.data.data.contacts));
        }
      })
      .catch(error => {
        // Невдалий фетч не має блокувати наступну спробу на весь TTL.
        userInfoStamp = { token: null, at: 0 };
        dispatch(actions.profile.profileError(error?.response?.data?.data));
      })
      .finally(() => dispatch(actions.profile.stopFetching()));
  };
}


export function editUserInfoThunk(data) {
  // Проміс повертаємо назовні: після зміни часового поясу треба дочекатись збереження
  // і тільки тоді перечитувати профіль, інакше прилетить ще старе значення.
  return (dispatch) => {
    dispatch(actions.profile.startFetching());
    return edit(data)
      .then(res => {
        if (res.data.info.status) {
          dispatch(actions.profile.editUserInfo(true));

          if (res.data.data.phone) {
            dispatch(actions.profile.editUserPhone(res.data.data.phone));
            localStorage.setItem('phone', JSON.stringify(res.data.data.phone));
            localStorage.setItem('messageText', JSON.stringify(res.data.data.message));
          }
        }
      })
      .catch(error => {
        // Без ?. мережева помилка (немає error.response) кидала TypeError усередині catch
        // і проміс, який чекає TimezoneSelect, реджектився замість тихої обробки.
        dispatch(actions.profile.profileError(error?.response?.data?.data));
      })
      .finally(() => dispatch(actions.profile.stopFetching()));
  };
}

export function getCodeAgainThunk(data) {
  return (dispatch) => {
    phoneAgain(data)
      .then(res => {
        if (res.data.info.status) {
          dispatch(actions.profile.editUserPhone(res.data.data.phone));
          localStorage.setItem('phone', JSON.stringify(res.data.data.phone));
          localStorage.setItem('messageText', JSON.stringify(res.data.data.message));
        }
      })
      .catch(error => {
        dispatch(actions.profile.profileError(error.response.data.data));
      });
  };
}

export function editPhoneCodeThunk(data) {
  return (dispatch) => {
    dispatch(actions.profile.startFetching());
    code(data)
      .then(res => {
        if (res.data.info.status) {
          dispatch(actions.profile.editUserInfo(true));
        }
      })
      .catch(error => {
        dispatch(actions.profile.profileError(error.response.data.data));
      })
      .finally(() => dispatch(actions.profile.stopFetching()));
  };
}

export function checkChangedDataThunk(data) {
  return (dispatch) => {
    checkChanges(data)
      .then(res => {
        if (res.data.info.status) {
          dispatch(actions.profile.checkChangedData(res.data.data));
        }
      })
      .catch(error => {
        dispatch(actions.profile.profileError(error.response.data.data));
      });
  };
}

export function changedDataVerifiedThunk(data) {
  return (dispatch) => {
    changesVerified(data)
      .then(res => {
        if (res.data.info.status) {
          dispatch(actions.profile.changedDataVerified(true));
        }
      })
      .catch(error => {
        dispatch(actions.profile.profileError(error.response.data.data));
      });
  };
}

export function setTelegramThunk(data) {
  return (dispatch) => {
    telegram(data)
      .then(res => {
        if (res.data.info.status) {
          dispatch(actions.profile.telegram(res.data.data));
        }
      })
      .catch(error => {
        dispatch(actions.profile.profileError(error.response.data.data));
      });
  };
}

export function setBirthDateThunk(data) {
  return (dispatch) => {
    birthDate(data)
      .then(res => {
        if (res.data.info.status) {
          dispatch(actions.profile.birthDate(res.data.data));
        }
      })
      .catch(error => {
        dispatch(actions.profile.profileError(error.response.data.data));
      });
  };
}